import { Navigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionUtils";

const PermissionRoute = ({ permission, children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PermissionRoute;